import { isDefined } from '@sgme/fp';
import type { Action } from 'state/actions';
import { type HelpCenterState, initialHelpCenterState } from 'state/helpRequest/state';
import { addOrPatchKey } from 'state/utils/collection';

export function helpCenterReducer(
  state: HelpCenterState | undefined = initialHelpCenterState,
  action: Action,
): HelpCenterState {
  switch (action.type) {
    case 'HELP_CENTER_CLOSE':
      return { ...state, currentContext: undefined, topicToBeOpened: undefined };
    case 'HELP_CENTER_OPEN':
      if (isDefined(state.currentContext)) {
        return state;
      }
      return {
        ...state,
        currentContext: action.id,
        contexts: addOrPatchKey(state.contexts, action.id, s => ({ ...s, ...action.context })),
      };
    case 'HELP_CENTER_UPDATE_CONTEXT':
      return {
        ...state,
        contexts: addOrPatchKey(state.contexts, action.id, s => ({ ...s, ...action.context })),
      };
    case 'HELP_CENTER_TOPIC_OPEN':
      return {
        ...state,
        topicToBeOpened: action.topicId,
      };
  }
  return state;
}
